import React, { FC } from 'react';
import { Box, Typography, Button, Container, Paper, alpha, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MdOutlineSecurity, MdArrowBack, MdHome } from 'react-icons/md';
import Brand from '../../Assets/brand.webp';

const AccessDenied: FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.02)} 0%, ${alpha(theme.palette.secondary.main, 0.05)} 100%)`,
                overflow: 'hidden',
                position: 'relative'
            }}
        >
            {/* Elementos decorativos de fundo */}
            <Box sx={{ position: 'absolute', top: '10%', right: '10%', width: 300, height: 300, borderRadius: '50%', background: `radial-gradient(circle, ${alpha(theme.palette.primary.main, 0.1)} 0%, transparent 70%)`, filter: 'blur(50px)' }} />
            <Box sx={{ position: 'absolute', bottom: '10%', left: '10%', width: 200, height: 200, borderRadius: '50%', background: `radial-gradient(circle, ${alpha(theme.palette.secondary.main, 0.1)} 0%, transparent 70%)`, filter: 'blur(40px)' }} />

            <Container maxWidth="sm">
                <Paper
                    elevation={0}
                    sx={{
                        p: 6,
                        borderRadius: '32px',
                        textAlign: 'center',
                        backdropFilter: 'blur(10px)',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.05)',
                        position: 'relative',
                        zIndex: 1
                    }}
                >
                    <Box
                        component="img"
                        src={Brand}
                        alt="Papello"
                        sx={{
                            width: 140,
                            mb: 6,
                            opacity: 0.9
                        }}
                    />

                    <Box sx={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        mb: 3,
                        color: theme.palette.error.main 
                    }}>
                        <Box sx={{ 
                            p: 2, 
                            borderRadius: '24px', 
                            bgcolor: alpha(theme.palette.error.main, 0.1),
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <MdOutlineSecurity size={64} />
                        </Box>
                    </Box>

                    <Typography variant="h3" fontWeight={900} sx={{ color: 'text.primary', mb: 2, letterSpacing: -1.5 }}>
                        Acesso Restrito
                    </Typography>

                    <Typography variant="body1" sx={{ color: 'text.secondary', mb: 5, px: 2, fontWeight: 500, lineHeight: 1.6 }}>
                        Oops! Você não possui as permissões necessárias para acessar este recurso. 
                        Se você acredita que isso é um erro, por favor, entre em contato com o administrador do sistema.
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                        <Button
                            variant="outlined"
                            startIcon={<MdArrowBack />}
                            onClick={() => navigate(-1)}
                            sx={{
                                borderRadius: '14px',
                                px: 4,
                                py: 1.5,
                                textTransform: 'none',
                                fontWeight: 800,
                                borderColor: alpha(theme.palette.divider, 0.2),
                                color: 'text.primary',
                                '&:hover': {
                                    borderColor: theme.palette.primary.main,
                                    bgcolor: 'transparent'
                                }
                            }}
                        >
                            Voltar
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<MdHome />}
                            onClick={() => navigate('/')}
                            sx={{
                                borderRadius: '14px',
                                px: 4,
                                py: 1.5,
                                textTransform: 'none',
                                fontWeight: 800,
                                boxShadow: `0 8px 16px ${alpha(theme.palette.primary.main, 0.2)}`
                            }}
                        >
                            Ir para o Início
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export { AccessDenied };
